// extracted by mini-css-extract-plugin
module.exports =  {"spinner":"EditEntity__spinner--pU","spin":"EditEntity__spin--YJ"};